var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("header-profil", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", { staticClass: "profileDashboard" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("menu-profil", {
                attrs: { profil: _vm.profil, spravy: _vm.spravy }
              }),
              _vm._v(" "),
              _vm.profil.pouzivatel_id
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-md-12 col-lg-8 col-xl-9" },
                    [
                      _c("h2", [_vm._v("Zmena hesla")]),
                      _vm._v(" "),
                      _vm.responseText != ""
                        ? _c(
                            "div",
                            {
                              class: "alert alert-" + _vm.responseType,
                              attrs: { role: "alert" }
                            },
                            [
                              _c("span", {
                                class: "icon --" + _vm.responseType
                              }),
                              _vm._v(
                                _vm._s(_vm.responseText) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("form", { on: { submit: _vm.formSubmit } }, [
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                            _c("label", [_vm._v("Staré heslo")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.stare_heslo,
                                  expression: "stare_heslo"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "password" },
                              domProps: { value: _vm.stare_heslo },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.stare_heslo = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-12 col-md-6" })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                            _c("label", [_vm._v("Nové heslo")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.nove_heslo,
                                  expression: "nove_heslo"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "password" },
                              domProps: { value: _vm.nove_heslo },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.nove_heslo = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-12 col-md-6" })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                            _c("label", [_vm._v("Zopakovať nové heslo")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.zopakovat_heslo,
                                  expression: "zopakovat_heslo"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "password" },
                              domProps: { value: _vm.zopakovat_heslo },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.zopakovat_heslo = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-12 col-md-6" })
                        ]),
                        _vm._v(" "),
                        _vm._m(0)
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "button",
          { staticClass: "btn --primary", attrs: { type: "submit" } },
          [_vm._v("Potvrdiť nové heslo "), _c("span", { staticClass: "icon" })]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }